module.exports = __webpack_public_path__ + "img/companyIntro17.c0187c43.png";